function encodeSpecialCharacters(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }
    if (htmlContent.includes("<=")) {
        htmlContent = htmlContent.replace(/<=/g, "&lt=");
    }
    if (htmlContent.includes("=<")) {
        htmlContent = htmlContent.replace(/=</g, "=&lt");
    }
    if (htmlContent.includes(">=")) {
        htmlContent = htmlContent.replace(/>=/g, "&gt=");
    }
    if (htmlContent.includes("=>")) {
        htmlContent = htmlContent.replace(/=>/g, "=&gt");
    }

    return htmlContent;
}

function extractBody(htmlContent: string) {
    if (!htmlContent || htmlContent === "") {
        return htmlContent;
    }
    const bodyStart = htmlContent.indexOf("<body>");
    const bodyEnd = htmlContent.indexOf("</body>");
    return bodyStart >= 0 && bodyEnd >= 0 ? htmlContent.substring(bodyStart + 6, bodyEnd) : htmlContent;
}

export default function transformContentHtml(htmlContent: string) {
    const encoded = encodeSpecialCharacters(htmlContent);
    return extractBody(encoded);
}
